import { apiSlice } from '../../app/api/apiSlice';

export const settingsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSettings: builder.query({
            query: () => '/settings',
            providesTags: ['Settings']
        }),
        updateAiAgentStatus: builder.mutation({
            query: ({ enabled, reason }) => ({
                url: '/settings/ai-agent',
                method: 'PUT',
                body: { enabled, reason }
            }),
            invalidatesTags: ['Settings']
        }),
        updateChatbotVisibility: builder.mutation({
            query: ({ visible, reason }) => ({
                url: '/settings/chatbot-visibility',
                method: 'PUT',
                body: { visible, reason }
            }),
            invalidatesTags: ['Settings']
        }),
    })
});

export const {
    useGetSettingsQuery,
    useUpdateAiAgentStatusMutation,
    useUpdateChatbotVisibilityMutation
} = settingsApiSlice;
